<template>
  <v-container fluid class="intelligence-find-talent pa-4">
    <v-row>
      <v-col cols="12">
        <h1 class="text-h5 font-weight-bold mb-1 theme-heading">
          Find Talent
        </h1>
        <p class="text-subtitle-2 grey--text text--darken-1 mb-4">
          Search, match, and plan succession across your talent pool
        </p>
      </v-col>
    </v-row>

    <v-tabs v-model="activeTab" color="primary" slider-color="primary" background-color="transparent" class="mb-4">
      <v-tab href="#search">
        <v-icon small class="mr-2">mdi-magnify</v-icon>
        Smart Search
      </v-tab>
      <v-tab href="#jdmatch">
        <v-icon small class="mr-2">mdi-file-document-check</v-icon>
        JD Match
      </v-tab>
      <v-tab href="#succession">
        <v-icon small class="mr-2">mdi-account-switch</v-icon>
        Succession
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item value="search">
        <IntelligenceDiscover :embedded="true" />
      </v-tab-item>
      <v-tab-item value="jdmatch">
        <IntelligenceJDMatch :embedded="true" />
      </v-tab-item>
      <v-tab-item value="succession">
        <IntelligenceSuccessionPlanning :embedded="true" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import IntelligenceDiscover from "./IntelligenceDiscover.vue";
import IntelligenceJDMatch from "./IntelligenceJDMatch.vue";
import IntelligenceSuccessionPlanning from "./IntelligenceSuccessionPlanning.vue";

export default {
  name: "IntelligenceFindTalent",
  components: { IntelligenceDiscover, IntelligenceJDMatch, IntelligenceSuccessionPlanning },
  data() {
    return {
      activeTab: this.$route.query.tab || "search",
    };
  },
  watch: {
    activeTab(val) {
      if (val && val !== this.$route.query.tab) {
        this.$router.replace({ query: { ...this.$route.query, tab: val } }).catch(() => {});
      }
    },
    "$route.query.tab"(val) {
      if (val && val !== this.activeTab) {
        this.activeTab = val;
      }
    },
  },
};
</script>

<style scoped>
.intelligence-find-talent {
  max-width: 1400px;
}
</style>
